"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = exports._appendEnv = void 0;
const isNode = typeof window === "undefined";
const parseEnv = (dotEnvStr) => {
    // Try parse envfile string
    const obj = {};
    const lines = dotEnvStr.toString().split("\n");
    for (const line of lines) {
        const match = line.match(/^([^=:#]+?)[=:](.*)/);
        if (match) {
            const key = match[1].trim();
            // @ts-ignore
            obj[key] = match[2].trim();
        }
    }
    return obj;
};
const _appendEnv = (dotenvStr, globalObj, validator) => {
    var _a, _b;
    const obj = dotenvStr ? parseEnv(dotenvStr) : undefined;
    const env = Object.assign(Object.assign({}, globalObj === null || globalObj === void 0 ? void 0 : globalObj.env), obj);
    for (const [key, valid] of Object.entries(validator || {})) {
        // @ts-ignore
        if (!env[key]) {
            // @ts-ignore
            if (valid.default) {
                console.warn(`Env variable [${key}] missing. Using provided default value. ${
                // @ts-ignore
                (_a = valid.errorMessage) !== null && _a !== void 0 ? _a : ""}`);
                // @ts-ignore
                env[key] = valid.default;
            }
            else {
                const message = `Env variable [${key}] missing. ${
                // @ts-ignore
                (_b = valid.errorMessage) !== null && _b !== void 0 ? _b : ""}`;
                // @ts-ignore
                if (valid.critical && globalObj === process) {
                    console.error(message);
                    process.exit(1);
                }
                else {
                    throw new Error(message);
                }
            }
            // @ts-ignore
        }
        else if (valid.converter) {
            // @ts-ignore
            const value = env[key];
            // @ts-ignore
            env[key] = value && valid.converter(value);
        }
    }
    if (globalObj) {
        globalObj.env = env;
    }
    return env;
};
exports._appendEnv = _appendEnv;
const load = (options) => __awaiter(void 0, void 0, void 0, function* () {
    let loader;
    if (isNode) {
        loader = (yield Promise.resolve().then(() => __importStar(require("./node")))).load;
    }
    else {
        loader = (yield Promise.resolve().then(() => __importStar(require("./browser")))).load;
    }
    return loader ? loader(options) : {};
});
exports.load = load;
exports.default = exports.load;
//# sourceMappingURL=common.js.map